import { useTranslation } from "react-i18next";
import { useGetVehicleBrand } from "../../../../common/api/queries/enumerations";
import type { UUID } from "../../../../typings/global";
import { VEHICLE_OTHER_MAPPING_NAME } from "../../enums";

interface Props {
  brandId: UUID;
  otherBrandName?: string;
}

export const VehicleBrandEnumName = ({ brandId, otherBrandName }: Props) => {
  const { t } = useTranslation();

  const { data: brand, isFetched } = useGetVehicleBrand(brandId);

  if (!isFetched) {
    return null;
  }

  if (!brand) {
    return t("vehicle.helpers.unknownBrand");
  }

  return brand.name === VEHICLE_OTHER_MAPPING_NAME && otherBrandName ? (
    <>{`${brand.name} (${otherBrandName})`}</>
  ) : (
    <>{brand.name}</>
  );
};
